module.exports = __webpack_public_path__ + "static/img/empty.9b788263.png";